import { sendEventRegist, sendException } from 'helpers/analytics';
import {
  getChannelContextAdditionalInfo,
  getChannelContextCode,
  getJsonStringify
} from 'helpers/Utility';
import { setError } from 'store/actions/auth';
import { loading } from 'store/actions/loanApply';

const handleIncorrectOtpOrExpired = (dispatch, err) => {
  const addInfo = getChannelContextAdditionalInfo(err, 'channel-context');
  const freezeTime = addInfo?.freezeEnd;

  if (getChannelContextCode(err, 'channel-context') === '105412') {
    dispatch(setError('otp-expired'));
  } else if (getChannelContextCode(err, 'channel-context') === '4000301') {
    localStorage.setItem('otpFreeze', JSON.stringify({ freezeTime }));
    dispatch(setError('otp_temporary_locked'));
    dispatch(loading(false));
  } else if (getChannelContextCode(err, 'channel-context') === '4000300') {
    dispatch(setError('incorrect_otp'));
  } else if (getChannelContextCode(err, 'channel-context') === '405203') {
    dispatch(setError('otp-expired'));
  }
};

const handleConnectionError = dispatch => dispatch(setError('connection'));
const handleSystemError = dispatch => dispatch(setError('system'));

/**
 * Main function to handle create account error
 * @param {*} err
 * @param {*} dispatch
 * @param {*} action
 * @param {*} auth
 * @returns
 */
export const handleErrorCreateAccount = (err, dispatch, action, auth) => {
  const errResponse = err.response;
  const status = errResponse?.status;

  if (errResponse) {
    // Case: Incorrect OTP or OTP Expired
    if (status === 400) {
      handleIncorrectOtpOrExpired(dispatch, err);
    }

    action?.failed?.();
    action?.eventName?.(errResponse);

    sendEventRegist({
      action: 'User Wrong Input The OTP Register',
      label: auth.phoneNumber + ' - ' + getJsonStringify(errResponse)
    });
    sendException({
      desc: 'User Wrong Input The OTP',
      fatal: false
    });
  } else {
    if (err.toString().includes('Network Error')) {
      return handleConnectionError(dispatch);
    } else {
      return handleSystemError(dispatch);
    }
  }
};
